export default __webpack_public_path__ + "static/media/header.b13ec8c6.jpg";